import React from 'react';
import { liteClient as algoliasearch } from 'algoliasearch/lite';

export const AlgoliaConnectorContext = React.createContext<ReturnType<typeof algoliasearch>>(
    {} as ReturnType<typeof algoliasearch>
);
